import React from "react";
import SyncBtn from "../assets/images/icon/refresh.svg?react";
import EditBtn from "../assets/images/icon/edit.svg?react";
import DeleteBtn from "../assets/images/icon/delete.svg?react";
import Map from "../assets/images/icon/map.svg?react";
import MapSolid from "../assets/images/icon/map-solid.svg?react";
import Close from "../assets/images/icon/close.svg?react";
import View from "../assets/images/icon/view.svg?react";
import Filter from "../assets/images/icon/filter.svg?react";
import DocExcel from "../assets/images/icon/doc_exel.svg?react";
import PrintReport from "../assets/images/icon/print.svg?react";
import PDF from "../assets/images/icon/pdf.svg?react";
import RightArrrow from "../assets/images/icon/right_arrow.svg?react";
import DocCSV from "../assets/images/icon/CSV_file.svg?react";
import History from "../assets/images/icon/history.svg?react";
import RightTick from "../assets/images/icon/rightTick.svg?react";
import ChangePass from "../assets/images/icon/change_password.svg?react";
import Watch from "../assets/images/icon/watch.svg?react";
// import  AttenCamera from "../assets/images/icon/attendance_icon/camera_icon.svg";
// import  AttenNotes from "../assets/images/icon/attendance_icon/notes.svg";
// import  AttenOffice from "../assets/images/icon/attendance_icon/office.svg";
// import  AttenUser from "../assets/images/icon/attendance_icon/user.svg";
// import  AttenWatch from "../assets/images/icon/attendance_icon/watch.svg";
// import  AttenZone from "../assets/images/icon/attendance_icon/zone.svg";
// import  DashboardPendingAmount from "../assets/images/icon/dashboard/pending_amount.svg";
// import  DashboardReceivedAmount from "../assets/images/icon/dashboard/Received_Amount.svg";
// import  DashboardTaxAmount from "../assets/images/icon/dashboard/Tax_Amount.svg";
// import  DashboardTotalReport from "../assets/images/icon/dashboard/Total_Reports.svg";
// import  DashboardDogCaptured from "../assets/images/icon/dashboard/dog_captured.svg";
// import  DashboardActionNotTaken from "../assets/images/icon/dashboard/action_not_taken.svg";
// import  DashboardDogRealesed from "../assets/images/icon/dashboard/dog_Released.svg";
// import  DashboardDogSterlized from "../assets/images/icon/dashboard/dog_sterilized.svg";
// import  DashboardDogEscaped from "../assets/images/icon/dashboard/escaped_during_recieved.svg";
// import  DashboardDogFitRelease from "../assets/images/icon/dashboard/fit_Release.svg";
// import  DashboardDogReceived from "../assets/images/icon/dashboard/received.svg";
import FacebookSolid from "../assets/images/icon/facebook.svg?react";
import TwitterSolid from "../assets/images/icon/twitter.svg?react";
// import  DashboardPilotUnassigned from "../assets/images/icon/dashboard/total_unassigned.svg";
// import  DashboardPilotResolved from "../assets/images/icon/dashboard/total_resolved.svg";
// import  DashboardPilotPendingCompl from "../assets/images/icon/dashboard/total_pending_complaints.svg";
// import  DashboardPilotLongTerm from "../assets/images/icon/dashboard/total_long_term.svg";
// import  DashboardPilotComplaints from "../assets/images/icon/dashboard/total_complaints.svg";
// import  DashboardPilotSubmitApproval from "../assets/images/icon/dashboard/submit_for_approval.svg";
import Save from "../assets/images/save.svg?react";
import SavedFilled from "../assets/images/savedFilled.svg?react";
import ProfileUserIcon from "../assets/images/icon/user-icon.svg?react";
import EnergyCarrersIcon from "../assets/images/icon/energy-carrers-icon.svg?react";
import ResourcesIcon from "../assets/images/icon/resources-icon.svg?react";
import SavedCareersIcon from "../assets/images/icon/save-career-icon.svg?react";
import CareerDiscoveryIcon from "../assets/images/icon/career-discovery-icon.svg?react";
import UserLockIcon from "../assets/images/icon/user-lock-icon.svg?react";
import ProfileArrowIcon from "../assets/images/icon/profile-arrow-icon.svg?react";
import BreadcrumbArrowIcon from "../assets/images/icon/breadcrumb-arrow-icon.svg?react";
import InterestDiscoveryIcon from "../assets/images/icon/interest-discovery-icon.svg?react";
import SkillPortraitIcon from "../assets/images/icon/skill-portrait-icon.svg?react";
import CareerCompassIcon from "../assets/images/icon/career-compass-icon.svg?react";

interface IconProps {
  icon: string; //make the clear type to make switch
  color?: string;
  width?: number;
  className?: any;
}

const SVGIcon = ({
  icon,
  color = "#696b71",
  width = 20,
  className,
}: IconProps) => {
  // In this case you have to think about the switch and types in typescript.
  const Icons: any = {
    refresh: <SyncBtn fill={color} width={width} height={width} />,
    close: <Close fill={color} width={width} height={width} />,
    edit: <EditBtn fill={color} width={width} height={width} />,
    delete: <DeleteBtn fill={color} width={width} height={width} />,
    view: <View fill={color} width={width} height={width} />,
    map: <Map fill={color} width={width} height={width} />,
    mapSolid: <MapSolid fill={color} width={width} height={width} />,
    filter: <Filter fill={color} width={width} height={width} />,
    DocExcel: <DocExcel fill={color} width={width} height={width} />,
    DocCSV: <DocCSV fill={color} width={width} height={width} />,
    PrintReport: <PrintReport fill={color} width={width} height={width} />,
    PDF: <PDF fill={color} width={width} height={width} />,
    right_arrow: <RightArrrow fill={color} width={width} height={width} />,
    history: <History fill={color} width={width} height={width} />,
    rightTick: <RightTick fill={color} width={width} height={width} />,
    changePass: <ChangePass fill={color} width={width} height={width} />,
    watch: <Watch fill={color} width={width} height={width} />,

    FacebookSolid: <FacebookSolid fill={color} width={width} height={width} />,
    TwitterSolid: <TwitterSolid fill={color} width={width} height={width} />,

    Save: <Save fill={color} width={width} height={width} />,
    SavedFilled: <SavedFilled fill={color} width={width} height={width} />,

    ProfileUserIcon: (
      <ProfileUserIcon fill={color} width={width} height={width} />
    ),
    CareerDiscoveryIcon: (
      <CareerDiscoveryIcon
        fill={color}
        width={width}
        height={width}
        className={className}
      />
    ),
    EnergyCarrersIcon: (
      <EnergyCarrersIcon
        fill={color}
        width={width}
        height={width}
        className={className}
      />
    ),
    ResourcesIcon: (
      <ResourcesIcon
        fill={color}
        width={width}
        height={width}
        className={className}
      />
    ),
    SavedCareersIcon: (
      <SavedCareersIcon
        fill={color}
        width={width}
        height={width}
        className={className}
      />
    ),
    UserLockIcon: <UserLockIcon fill={color} width={width} height={width} />,
    ProfileArrowIcon: (
      <ProfileArrowIcon fill={color} width={width} height={width} />
    ),
    BreadcrumbArrowIcon: (
      <BreadcrumbArrowIcon fill={color} width={width} height={width} />
    ),

    InterestDiscoveryIcon: (
      <InterestDiscoveryIcon fill={color} width={width} height={width} />
    ),
    SkillPortraitIcon: (
      <SkillPortraitIcon fill={color} width={width} height={width} />
    ),
    CareerCompassIcon: (
      <CareerCompassIcon fill={color} width={width} height={width} />
    ),
  };
  return Icons[icon];
};

export default SVGIcon;
